module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-mv-sm-bfccea6f90fa16b28bbfc9f76f4c55c9.jpg";